import React from 'react';

const LoadingSpinner = ({ size = 'medium', color = 'cyan', className = '' }) => {
    // Size mapping
    const sizeClasses = {
        small: 'w-5 h-5 border-2',
        medium: 'w-8 h-8 border-4',
        large: 'w-12 h-12 border-4',
        xl: 'w-16 h-16 border-4',
    };

    // Color mapping (Tailwind classes)
    const colorClasses = {
        cyan: 'border-t-cyan-500 border-r-cyan-500/50 border-b-transparent border-l-transparent',
        purple: 'border-t-purple-500 border-r-purple-500/50 border-b-transparent border-l-transparent',
        white: 'border-t-white border-r-white/50 border-b-transparent border-l-transparent',
        blue: 'border-t-blue-500 border-r-blue-500/50 border-b-transparent border-l-transparent',
    };

    return (
        <div className={`flex items-center justify-center ${className}`}>
            <div 
                className={`
                    rounded-full animate-spin
                    ${sizeClasses[size] || sizeClasses.medium}
                    ${colorClasses[color] || colorClasses.cyan}
                `}
                role="status"
                aria-label="loading"
            >
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    );
};

export default LoadingSpinner;